import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Save, Lock, Key, ExternalLink } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import NotificationChannelsAdmin from '../../components/admin/NotificationChannelsAdmin';
import { LlavesApi, ApiDocs } from '../agencia/Integraciones';
import AgenciaMediosPago from '../agencia/MediosPago';

export const SECCIONES = [
  { key: 'medios-pago', label: 'Medios de pago' },
  { key: 'notificaciones', label: 'Notificaciones' },
  { key: 'integraciones', label: 'Integraciones' },
  { key: 'cuenta', label: 'Mi cuenta' },
];

export default function AdminSettings() {
  const location = useLocation();
  const navigate = useNavigate();
  const seccion = (location.hash || '').replace('#', '') || 'medios-pago';

  const [currentPass, setCurrentPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [saving, setSaving] = useState(false);
  const [apify, setApify] = useState({ set: false, hint: '' });
  const [apifyToken, setApifyToken] = useState('');
  const [savingApify, setSavingApify] = useState(false);

  useEffect(() => {
    api.get('/admin/integrations').then(r => setApify({ set: r.data.apify_token_set, hint: r.data.apify_token_hint })).catch(() => {});
  }, []);

  const saveApify = async (e) => {
    e.preventDefault();
    setSavingApify(true);
    try {
      await api.put('/admin/integrations', { apify_token: apifyToken });
      toast.success('Token de Apify guardado');
      setApifyToken('');
      const r = await api.get('/admin/integrations');
      setApify({ set: r.data.apify_token_set, hint: r.data.apify_token_hint });
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
    finally { setSavingApify(false); }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPass !== confirmPass) return toast.error('Las contraseñas no coinciden');
    if (newPass.length < 8) return toast.error('Mínimo 8 caracteres');
    setSaving(true);
    try {
      await api.put('/auth/change-password', { current_password: currentPass, new_password: newPass });
      toast.success('Contraseña actualizada');
      setCurrentPass(''); setNewPass(''); setConfirmPass('');
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const chip = (a) => ({
    padding: '7px 14px', borderRadius: 999, fontSize: 13, fontWeight: 600, cursor: 'pointer',
    border: '1px solid ' + (a ? 'var(--accent)' : 'var(--border)'),
    background: a ? 'var(--accent)' : 'transparent', color: a ? '#fff' : 'var(--text-secondary)',
  });
  const dos = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 1fr))', gap: 20, alignItems: 'start' };

  return (
    <div>
      <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 18 }}>Configuración</h1>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 22 }}>
        {SECCIONES.map(s => (
          <div key={s.key} style={chip(seccion === s.key)} onClick={() => navigate('/settings#' + s.key)}>{s.label}</div>
        ))}
      </div>

      {seccion === 'medios-pago' && <AgenciaMediosPago embebido />}

      {seccion === 'notificaciones' && <div style={dos}><NotificationChannelsAdmin /></div>}

      {seccion === 'integraciones' && (
        <div style={dos}>
          <LlavesApi />
          <div className="card">
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }}><Key size={18} /> Apify (Research)</h3>
            <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 14 }}>Un solo token para todos los clientes. Se usa al importar bases desde Research.</p>
            <div style={{ fontSize: 13, marginBottom: 12 }}>
              {apify.set ? <>Token configurado: <b>{apify.hint}</b></> : <span style={{ color: 'var(--danger)' }}>Sin token configurado</span>}
            </div>
            <form onSubmit={saveApify}>
              <div className="form-group"><label>{apify.set ? 'Reemplazar token' : 'API Token de Apify'}</label>
                <input type="password" value={apifyToken} onChange={e => setApifyToken(e.target.value)} placeholder="apify_api_XXXXXXXXXXXXXXX" required /></div>
              <a href="https://console.apify.com/account/integrations" target="_blank" rel="noopener noreferrer"
                style={{ fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 12 }}>
                <ExternalLink size={12} /> Obtener el token en Apify</a>
              <div><button type="submit" className="btn btn-primary" disabled={savingApify}><Save size={16} /> {savingApify ? 'Guardando...' : 'Guardar token'}</button></div>
            </form>
          </div>
          <ApiDocs />
        </div>
      )}

      {seccion === 'cuenta' && (
        <div style={dos}>
          <div className="card">
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}><Lock size={18} /> Cambiar contraseña</h3>
            <form onSubmit={handleChangePassword}>
              <div className="form-group"><label>Contraseña actual</label><input type="password" value={currentPass} onChange={e => setCurrentPass(e.target.value)} required /></div>
              <div className="form-group"><label>Nueva contraseña</label><input type="password" value={newPass} onChange={e => setNewPass(e.target.value)} required /></div>
              <div className="form-group"><label>Confirmar nueva contraseña</label><input type="password" value={confirmPass} onChange={e => setConfirmPass(e.target.value)} required /></div>
              <button type="submit" className="btn btn-primary" disabled={saving}><Save size={16} /> {saving ? 'Guardando...' : 'Guardar'}</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
